import React, { FunctionComponent } from 'react';

import { RouterLink } from 'app/src/components/RouterLink';
import { useTrelloCardQuery } from './TrelloCardQuery.generated';

import { KnownService, KnownServiceComponentProps } from './KnownService';

// eslint-disable-next-line @trello/less-matches-component
import styles from './KnownService.less';

interface OwnProps extends KnownServiceComponentProps {
  fullUrl: string;
  pathname: string;
  shortLink: string;
}

interface TrelloCardComponentUnconnectedProps extends OwnProps {
  card?: {
    url: string;
    name: string;
  };
}

export const TrelloCardComponentUnconnected = (
  props: TrelloCardComponentUnconnectedProps,
) => {
  const { card, fullUrl, pathname, shortLink, ...rest } = props;
  const anchorProps = rest;

  const fallbackUrl = shortLink ? `/c/${shortLink}` : pathname;
  const url = card?.url ? card.url : fallbackUrl;
  const name = card?.name ? card.name : fullUrl;

  return (
    <RouterLink
      {...anchorProps}
      href={url}
      className={styles.knownServiceLink}
      target=""
      rel=""
    >
      <img
        className={styles.knownServiceIcon}
        alt="Trello Icon"
        src={require('resources/images/services/trello.png')}
      />
      {name}
    </RouterLink>
  );
};

const TrelloCardComponent: FunctionComponent<OwnProps> = ({
  shortLink,
  fullUrl,
  pathname,
}) => {
  const { data, loading } = useTrelloCardQuery({
    variables: {
      shortLink: shortLink,
    },
    skip: !shortLink,
  });

  if (loading || !data?.card) {
    return null;
  }

  const card = data.card;

  return (
    <TrelloCardComponentUnconnected
      fullUrl={fullUrl}
      shortLink={shortLink}
      pathname={pathname}
      card={card}
    />
  );
};

export const TrelloCard: KnownService<OwnProps> = {
  match: {
    protocol: location.protocol,
    host: location.host,
    pathname: new RegExp(`^/c/([a-zA-Z0-9]{8})(?:$|/.*)`),
  },
  getMatchProps: ([fullUrl, pathname, shortLink]: string[]) => {
    return { fullUrl, pathname, shortLink };
  },
  Component: TrelloCardComponent,
};
